module.exports = {"id":"179768","name":"Charles Kaboré","rating":"77","photo":"./data/images/photos/1/179768.png","club":{"name":"FK Krasnodar","logo":"./data/images/clubs/FKKrasnodar.png"},"positions":["MDC","MC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/CharlesKabore0.json
// module id = 761
// module chunks = 0